import {ServicesDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'CREATE_SERVICE';

export async function createService(token: string, payload: Record<string, unknown>) {
    try {
        const result = await ServicesDao.createService(token, payload);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création du service',
            error: error
        });
    }
}
